import React from 'react'

export default function ColorIcon ({
  fill = '#000000',
  outline = '#000000',
  outlineWidth = 2,
  size = 24
}) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24'>
      <circle
        cx='12'
        cy='12'
        r={12 - outlineWidth / 2}
        fill={fill}
        stroke={outline}
        strokeWidth={outlineWidth}
      />
    </svg>
  )
}
